import styled from 'styled-components';

import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $MenuList = styled.div`
  padding: ${spacing(2.5)};
  bordertop: 1px solid #eee;
  textalign: center;
  color: ${({ theme }) => theme.colors.primary};
  fontweight: ${fontWeight('medium')};
  cursor: pointer;
`;
